import { filtersDefault } from '@/contexts/orderHistory/reducers/filters'
import { ordersDefault } from '@/contexts/orderHistory/reducers/orders'
import {
  OrderHistoryReducers,
  OrderHistoryStore,
} from '@/hooks/orderHistory/types'
import { ReactNode } from 'react'
import { createContext } from 'use-context-selector'
import combinedReducers from './reducers'

export const StateContext = createContext<OrderHistoryStore>({
  store: { filtersStore: filtersDefault, ordersStore: ordersDefault },
})
export const UpdaterContext = createContext<OrderHistoryReducers>({
  reducers: {
    ordersDispatch: () => null,
    filtersDispatch: () => null,
  },
})

interface Props {
  children: ReactNode
}

const OrderHistoryStoreProvider = ({ children }: Props) => {
  const { store, reducers } = combinedReducers()

  return (
    <StateContext.Provider value={{ store }}>
      <UpdaterContext.Provider value={{ reducers }}>
        {children}
      </UpdaterContext.Provider>
    </StateContext.Provider>
  )
}
export default OrderHistoryStoreProvider
